/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import Select from 'react-select'
import FromToPicker from '../BaseComponent/FromToPicker'

class DriverCartStation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      drivers: [],
      printInfo: [],
      DriversCount: 0,
      modalActivate: false,
      modalBlock: false,
      modalReset: false,
      modalChangeCar: false,
      cars: [],
      modalDelete: false,
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'id_asc',
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'رساننده',
          value: 'personId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ',
          value: 'deliveryDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'جایگاه',
          value: 'cartStationId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'ویرایش',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      cartStations: [],
      editModal: false,
      cartStationsList: [],
      driverId: '',
      cartStationId: ''
    }
  }

  getDrivers = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getCartStations = () => {
    return http
      .get(`cartStation/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          var carts = response.data.object
          for (let i = 0; i < carts.length; i++) {
            carts[i]['value'] = carts[i].id
            carts[i]['label'] = carts[i].id + ' - ' + carts[i].title
          }
          this.setState({
            cartStationsList: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.export = exportStatus
    let deliveryDateMin = this.state.deliveryDateMin
    let deliveryDateMax = this.state.deliveryDateMax
    let driverId = this.state.driverId === null || this.state.driverId === '' ? '' : this.state.driverId.personId
    let cartStation =
      this.state.cartStationId === null || this.state.cartStationId === '' ? '' : this.state.cartStationId.id
    if (deliveryDateMin !== '') {
      filter.deliveryDateMin = deliveryDateMin
    }
    if (deliveryDateMax !== '') {
      filter.deliveryDateMax = deliveryDateMax
    }
    if (driverId !== '') {
      filter.driverId = driverId
    }
    if (cartStation !== '') {
      filter.cartStationId = cartStation
    }
    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`cartStationDriver/report`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              cartStations: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    this.getDrivers()
    this.getCartStations()
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    this.getReport(false)
  }

  openActivate = (id, enabled) => {
    if (enabled) {
      http
        .patch(`cartStation/${id}/disable`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getReport(false)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      http
        .patch(`cartStation/${id}/enable`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getReport(false)
          } else {
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteStation = (id, driverName, date) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      id,
      driverName,
      date
    })
  }

  deleteOk = () => {
    let {id} = this.state
    http
      .delete(`cartStationDriver/${id}/delete`, {})
      .then((response) => {
        if (response.data.error === null) {
          message.success('جایگاه رساننده با موفقیت حذف شد')
          this.getReport(false)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch(() => {})
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getReport(false)
      }
    )
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`cartStationDriver/report`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          let res = response.data.object.result
          res.forEach((item) => {
            item.deliveryDate = jMoment(item.deliveryDate).format('jYYYY/jMM/jDD')
          })
          this.setState({
            excelReport: res
          })
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  selectedDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  selectCartStation = (cartStationId) => {
    this.setState({
      cartStationId
    })
  }

  handleChangeFrom = (deliveryDateMin) => {
    this.setState({
      deliveryDateMin
    })
  }

  handleChangeTo = (deliveryDateMax) => {
    this.setState({
      deliveryDateMax
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let printCol = ['ردیف', 'رساننده', 'تاریخ', 'جایگاه']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست جایگاه رساننده ها"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={1}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.driver !== null && item.driver.name}</td>
                  <td>{item.deliveryDate == null ? '-' : jMoment(item.deliveryDate).format('jYYYY/jM/jD')}</td>
                  <td>{item.cartStation !== null && item.cartStation.title}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست جایگاه رساننده ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driverName'}
                field={'driver.name'}
                title={'رساننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveryDate'}
                field={'deliveryDate'}
                title={'تاریخ'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'cartStation'}
                field={'cartStation.title'}
                title={'جایگاه'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>جایگاه</li>
            <li>لیست جایگاه رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/driverCartStation/create'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFrom}
                  onChangeToDate={this.handleChangeTo}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={false}
                  fromId="fromReg"
                  toId="toReg"
                />

                <div className="formComponent">
                  <label>رساننده</label>
                  <Select
                    value={this.state.driver}
                    onChange={this.selectedDriver}
                    options={this.state.drivers}
                    isClearable={true}
                    placeholder=""
                  />
                </div>
                <div className="formComponent">
                  <label>جایگاه</label>
                  <Select
                    value={this.state.cartStationId}
                    onChange={this.selectCartStation}
                    options={this.state.cartStationsList}
                    isClearable={true}
                    placeholder=""
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.cartStations.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.driver !== null && item.driver.name}</td>
                      <td>{item.deliveryDate == null ? '-' : jMoment(item.deliveryDate).format('jYYYY/jM/jD')}</td>
                      <td>{item.cartStation !== null && item.cartStation.title}</td>
                      <td>
                        <Link to={`/driverCartStation/edit/${item.id}`}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.deleteStation(
                              item.id,
                              item.driver.name,
                              jMoment(item.deliveryDate).format('jYYYY/jM/jD')
                            )
                          }
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({modalDelete: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalDelete: false})}>حذف جایگاه</ModalHeader>
          <ModalBody>
            <h5 className="font-weight-bold text-center">
              {' آیا از حذف جایگاه ' + this.state.driverName + ' در تاریخ ' + this.state.date + ' اطمینان دارید ؟؟ '}
            </h5>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف جایگاه
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalDelete: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DriverCartStation
